import Head from 'next/head';
import React from "react";
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { useRouter } from 'next/router';

import Main from 'Ifloorplan/containers/Main';
import rootReducer from 'Ifloorplan/redux/reducers/rootReducer';

const store = createStore(rootReducer, applyMiddleware(thunk));

function IFloorPlan() {
    const router = useRouter();
    const pk = router.query.id;
    return <>
        <Head>
            <title>{router.asPath.includes('/ifloorplan') ? 'iFloorPlan ' : ''}{pk}</title>
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
            <style>{'* { touch-action: pan-x pan-y; }'}</style>
            <link rel="stylesheet" href="/static/frontend/styles/ifloorplan.css" />
            <link rel="stylesheet" href="/static/user/fonts/font-awesome/css/font-awesome.min.css" />
            <link rel="stylesheet" href="/static/user/fonts/font-awesome/css/font-awesome.css" />
            <link rel="shortcut icon" href={router.asPath.includes('/ifloorplan') ? "/favicon.ico" : "/static/white-label-favicon.png"} />
        </Head>

        <div style={{ textAlign: "center" }}>
            <div id="app">
                <div className="NewWrapper">
                    <Provider store={store}>
                        <Main />
                    </Provider>
                </div>
            </div>
        </div>
    </>;
}

export default IFloorPlan;
